<script setup lang="ts">
import { onBeforeUnmount, onMounted } from "vue";
import { DsButton } from "@demvsystems/design-components";
import SvgVue from "@/application/components/SvgVue";
import ActionSheet from "@/application/components/ActionSheet.vue";
import { isInMaintenance } from "@/application/composables/maintenanceMode";
import { useGet } from "@/api/lib/integration";

// a successful response resets the maintenance flag inside makeRequest
const ping = useGet('/api/csrf-cookie');

async function retry(): Promise<void> {
  await ping();
}

let interval: ReturnType<typeof setInterval> | undefined;

onMounted(() => {
  interval = setInterval(() => {
    if (isInMaintenance.value) void retry();
  }, 10000);
});

onBeforeUnmount(() => clearInterval(interval));
</script>

<template>
  <Transition name="fade">
    <div
      v-if="isInMaintenance"
      class="overlay bg-white relative min-h-dvh flex flex-col"
    >
      <div class="welcome-image sticky top-0" />

      <ActionSheet
        class="-mt-10 relative grow"
        title="Wartungsarbeiten"
      >
        <div class="w-32 mx-auto mt-10 mb-5">
          <SvgVue icon="bannerVertical.svg" />
        </div>
        <div class="text-gray-700 text-sm text-center mb-10 px-6">
          Der Finanzmanager wird gerade gewartet und ist in Kürze wieder für Sie erreichbar.
        </div>
        <div class="text-center mb-10">
          <DsButton
            :handler="retry"
            size="lg"
          >
            Erneut versuchen
          </DsButton>
        </div>
      </ActionSheet>
    </div>
  </Transition>
</template>

<style scoped>
.welcome-image {
  height: 50dvh;
  background-size: cover;
  background-position: center center;
  background-image: url('../../../../assets/welcome.jpg');
}
</style>
